import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["pointsField"]

  connect() {
    this.formChanged = false;

    // Track changes on all points fields
    this.pointsFieldTargets.forEach(field => {
      field.addEventListener('input', this.markAsChanged.bind(this));
    });

    // Handle form submission
    this.element.addEventListener('submit', this.handleFormSubmission.bind(this));

    // Warn on page unload if there are unsaved changes
    window.addEventListener('beforeunload', this.confirmNavigation.bind(this));

    // Handle manual navigation confirmation
    this.setupNavigationListeners();
  }

  markAsChanged() {
    this.formChanged = true;
  }

  handleFormSubmission(event) {
    // Form submission should reset the formChanged flag
    this.formChanged = false;
  }

  confirmNavigation(event) {
    if (this.formChanged) {
      const message = "You have unsaved changes. Are you sure you want to leave this page?";
      event.returnValue = message; // Standard for browser prompt
      return message; // For compatibility with some browsers
    }
  }

  setupNavigationListeners() {
    // Handle pagination link clicks
    document.addEventListener('click', this.handlePaginationClick.bind(this));

    // Handle items per page select change
    document.addEventListener('change', this.handleItemsPerPageChange.bind(this));

    // Listen for custom navigation confirmation event
    document.addEventListener('custom:confirm-navigation', this.handleConfirmNavigation.bind(this));
  }

  handlePaginationClick(event) {
    const link = event.target.closest('.pagination a');
    if (link && this.formChanged) {
      if (!confirm("You have unsaved changes. Are you sure you want to leave this page?")) {
        event.preventDefault(); // Prevent navigation if user cancels
      } else {
        // Dispatch custom event to reset formChanged if user confirms
        document.dispatchEvent(new CustomEvent('custom:confirm-navigation'));
      }
    }
  }

  handleItemsPerPageChange(event) {
    const select = event.target.closest('select[name="per_page"]');
    if (select && this.formChanged) {
      if (!confirm("You have unsaved changes. Are you sure you want to leave this page?")) {
        event.preventDefault(); // Prevent form submission if user cancels
      } else {
        // Dispatch custom event to reset formChanged if user confirms
        document.dispatchEvent(new CustomEvent('custom:confirm-navigation'));
      }
    }
  }

  handleConfirmNavigation() {
    this.formChanged = false; // Reset formChanged after confirmation
  }
}
